import dayjs from "dayjs";

export const TIPO_CITA_OPTIONS = [
  { value: "consulta_general", label: "Consulta general" },
  { value: "seguimiento", label: "Seguimiento" },
  { value: "cirugia", label: "Cirugía" },
  { value: "optometria", label: "Optometría" },
];

export const ESTADO_OPTIONS = [
  { value: "confirmada", label: "Confirmada" },
  { value: "reagendada", label: "Reagendada" },
  { value: "cancelada", label: "Cancelada" },
  { value: "no_show", label: "No se presentó" },
  { value: "completada", label: "Completada" },
];

export const ESTADO_COLORS = {
  confirmada: "blue",
  reagendada: "gold",
  cancelada: "red",
  no_show: "volcano",
  completada: "green",
};

export const TIPO_CITA_LABELS = TIPO_CITA_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o.label;
  return acc;
}, {});

export const ESTADO_LABELS = ESTADO_OPTIONS.reduce((acc, o) => {
  acc[o.value] = o.label;
  return acc;
}, {});

export function esMenorDeEdad(fechaNacimiento) {
  if (!fechaNacimiento) return false;
  const nacimiento = dayjs(fechaNacimiento);
  if (!nacimiento.isValid()) return false;
  return dayjs().diff(nacimiento, "year") < 18;
}

export function formatHora(fechaHora) {
  const d = dayjs(fechaHora);
  return d.isValid() ? d.format("HH:mm") : "";
}

export function formatFechaLarga(fecha) {
  const d = dayjs(fecha);
  return d.isValid() ? d.format("dddd D [de] MMMM [de] YYYY") : fecha;
}
